<template>
  <qx-card title="投保记录" class="detail">
    <qx-img-dialog ref="imgDialog" />
    <section slot="titleRight">
      <qx-permpisions permpisions="">
        <ExportBtn :len="tableData.data.length"
          queryUrl="vehicleServiceBO.ajax?cmd=queryVehicleCertificatesInsurance"
          :params="fullSearchData"
          bizName="车辆投保记录导出"
                   :excelKeys="downloadParams.excelKeys"
                   :excelLables="downloadParams.excelLables"
        />
      </qx-permpisions>
    </section>

    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
        >
          <!-- 常规列表项 -->
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :filters="item.filters"
            :filter-method="item.filterHandler"
            :min-width="item.minW"
            :width="item.w"
          >
            <section slot-scope="scope">
              <section v-if="scope.column.property === 'picList' && scope.row[scope.column.property]!==''" >
                <span v-for="(item,index) in scope.row[scope.column.property]" :key="index">
                  <img :src="item.fullPathUrl" style="width:100px;height:100px;cursor:pointer"
                       v-if="item.fullPathUrl.substring(item.fullPathUrl.lastIndexOf('.') + 1) !== 'pdf'"
                       @click="previewImg(item.fullPathUrl)"/>
                  <a
                      class="cur"
                      v-if="item.fullPathUrl.substring(item.fullPathUrl.lastIndexOf('.') + 1) === 'pdf'"
                      :href="item.fullPathUrl"
                      target="_blank"
                  >
                    <img style="width:100px;height:100px;cursor:pointer" src="~images/pdf-icon.png" />
                  </a>
                </span>
              </section>
              <section v-else>{{ scope.row[scope.column.property] }}</section>
            </section>
            <!-- <section slot-scope="scope"></section> -->
          </el-table-column>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total || 0"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import ExportBtn from 'components/exportBtn';
import tableMixin from '@qx/mixin/table';
import {
  queryVehicleCertificatesInsurance,
} from 'api/car';
export default {
  mixins: [
    tableMixin,
  ],
  prop: {
    vehicleInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    ExportBtn,
  },
  data () {
    return {
      searchBoxData: {
        vehicleCode: this.$route.query.id || -1,
        flg: '1',
      },
      downloadParams: {
        excelKeys: 'certificatesInsuranceTypeName,insuranceCompany,insuranceCode,insuranceInsurant,certificatesInsuranceFee' +
            'handleDate,insuranceStartDate,insuranceEndDate,insuranceTerminationDate,backInsuranceFee,stateName',
        excelLables: '保险类型,保险公司,保单号,被保险人,保险金额,购买时间,生效日期,到期日期,终止时间,退保费,状态',
      },
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        title: [ // 表头
          {
            prop: 'certificatesInsuranceTypeName',
            label: '保险类型',
          },
          {
            prop: 'insuranceCompany',
            label: '保险公司',
          },
          {
            prop: 'insuranceCode',
            label: '保单号',
          },
          {
            prop: 'insuranceInsurant',
            label: '被保险人',
          },
          {
            prop: 'certificatesInsuranceFee',
            label: '保险金额',
          },
          {
            prop: 'handleDate',
            label: '购买时间',
          },
          {
            prop: 'insuranceStartDate',
            label: '生效日期',
          },
          {
            prop: 'insuranceEndDate',
            label: '到期日期',
          },
          {
            prop: 'insuranceTerminationDate',
            label: '终止时间',
          },
          {
            prop: 'backInsuranceFee',
            label: '退保费',
          },
          {
            prop: 'stateName',
            label: '状态',
          },
          {
            prop: 'picList',
            label: '保险附件',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: queryVehicleCertificatesInsurance,
    previewImg (url) {
      this.$refs.imgDialog.show(url);
    },
  },
};
</script>

<style>
</style>
